export const FAVORITE_ACTIVITIES_PATH = '/favorites/activities'
export const FAVORITE_ACTIVITIES_DELETE_PATH = id => `${FAVORITE_ACTIVITIES_PATH}/${id}`
